"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BHistory = void 0;
var react_1 = __importStar(require("react"));
var browser_history_1 = require("../../modules/browser_history");
var text_1 = require("../text");
require("./bhistory.less");
/**
 * 访问浏览历史记录
 * @param props
 * @returns
 */
function BHistory(props) {
    var size = props.size || 8;
    var _a = (0, react_1.useState)([]), showdata = _a[0], SetShowData = _a[1];
    (0, react_1.useEffect)(function () {
        //读取记录
        SetShowData((0, browser_history_1.getHistory)(size));
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, showdata.map(function (v, index) {
        return react_1.default.createElement("a", { key: index, href: v.link, target: "_blank", title: v.name },
            react_1.default.createElement(text_1.TextCut, { width: 88 }, v.name));
    })));
}
exports.BHistory = BHistory;
